import { makeStyles } from '@material-ui/core/styles';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';

const useStyles = makeStyles(theme => ({
  row: { display: 'flex', flexWrap: 'wrap', gap: theme.spacing(1) },
  link: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 4,
    padding: '2px 8px',
    borderRadius: 6,
    fontSize: 13,
    fontWeight: 500,
    whiteSpace: 'nowrap',
    color: theme.palette.primary.main,
    border: `1px solid ${theme.palette.divider}`,
    '&:hover': {
      borderColor: theme.palette.primary.main,
      textDecoration: 'none',
    },
  },
}));

/** A wrapping row of small outlined links to external tools, each opening in a new tab. */
export function LinkChips({
  links,
  'aria-label': ariaLabel,
}: {
  links: Array<{ title: string; url: string }>;
  'aria-label'?: string;
}) {
  const classes = useStyles();
  return (
    <div className={classes.row} role="group" aria-label={ariaLabel}>
      {links.map(l => (
        <a
          key={l.title}
          className={classes.link}
          href={l.url}
          target="_blank"
          rel="noopener noreferrer"
        >
          {l.title}
          <OpenInNewIcon style={{ fontSize: 13 }} aria-hidden="true" />
        </a>
      ))}
    </div>
  );
}
